import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
  OnDestroy,
} from '@angular/core'
import { MenuItem } from 'primeng/api'
import { Observable, zip, Subject } from 'rxjs'
import { map } from 'rxjs/operators'

import { AuthManagerService } from '@services/auth/auth-manager.service'
import { TranslatorService } from '@app/core/services/translator/translator.service'

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
})
export class UserInfoComponent implements OnInit, OnDestroy {
  items$: Observable<MenuItem[]>
  name: string
  showChangePasswd = false
  destroy$: Subject<boolean> = new Subject<boolean>()
  @Output() logoutEvt = new EventEmitter()
  @ViewChild('menu', { static: false }) menu

  constructor(
    private authService: AuthManagerService,
    private translatorService: TranslatorService
  ) {
    this.name = this.authService.getUserName()
  }

  ngOnInit() {
    this.items$ = zip(
      this.translatorService.getMessage('Change Password'),
      this.translatorService.getMessage('Logout')
    ).pipe(
      map(([changePasswordLabel, logoutLabel]) => {
        return [
          {
            label: changePasswordLabel,
            command: (event) => {
              this.openChangePasswordComponent()
            },
          },
          {
            label: logoutLabel,
            command: (event) => {
              this.menu.toggle('hide')
              this.logoutEvt.emit()
            },
          },
        ]
      })
    )
  }
  /**
   * Open the ChangePassword Component within a dialog
   */
  openChangePasswordComponent(): void {
    this.menu.toggle('hide')
    this.showChangePasswd = true
  }
  
  hideChangePasswd() {
    this.showChangePasswd = false
  }
  /**
   * Destroy the component
   */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }
}
